<template>
  <div :class="{'nav-open': $sidebar.showSidebar}" id="app">
    <notifications transition-name="notification-list" transition-mode="out-in"></notifications>

    <!--     <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> |
      <router-link to="/otro">otro</router-link> |
      <router-link to="/demo">demo</router-link> |
      <router-link to="/feathers">feathers</router-link> |
      <router-link to="/feathers-simple">feathers-simple</router-link> |
      <router-link to="/typeahead1">typeahead1</router-link> |
      <router-link to="/typeahead2">typeahead2</router-link> |
      <router-link to="/forms1">forms1</router-link> |
      <router-link to="/forms2">forms2 (styles)</router-link> |
      <router-link to="/muuri">muuri</router-link> |
      <router-link to="/debug1">debug1</router-link> |
      <router-link to="/full">full</router-link>
    </div> -->
    <!-- <router-view/> -->

    <router-view name="header"></router-view><!-- no hace nada por ahora -->
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <router-view name="footer"></router-view><!-- no hace nada por ahora -->

  </div>
</template>

<script>
// Loading some plugin css asynchronously

// load bootstrap (base)
import 'bootstrap/dist/css/bootstrap.min.css'

// load template
import '@/assets/sass/paper-dashboard.scss'
import '@/assets/sass/element_variables.scss'
import '@/assets/sass/demo.scss'
import '@/assets/sass/extras.scss'

// load other stuff
import 'sweetalert2/dist/sweetalert2.css'
import 'vue-notifyjs/themes/default.css'

// @todo ver si acá puedo cargar como módulos los css y js que cargo en /public/index.html (bootstrap.css por ejemplo)


export default {}
</script>

<style lang="less">
  .page-link {
    color: #17a2b8;
  }
</style>
